var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        title: _vm.$t("chatbotv2.exportDiagram"),
        visible: _vm.visible,
        footer: null,
        width: 700,
        wrapClassName: "export-diagram-modal",
      },
      on: {
        cancel: function ($event) {
          return _vm.$emit("close")
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "export-container" },
        [
          _c("div", { staticClass: "export-description" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("chatbotv2.exportDiagramDescription")) +
                "\n        "
            ),
          ]),
          _vm._v(" "),
          _c("a-spin", { attrs: { spinning: _vm.loading } }, [
            _c("div", { staticClass: "export-section" }, [
              _c(
                "div",
                { staticClass: "section-header" },
                [
                  _c("span", { staticClass: "section-title" }, [
                    _vm._v(_vm._s(_vm.$t("chatbotv2.diagram"))),
                  ]),
                  _vm._v(" "),
                  _c("a-switch", { attrs: { checked: true, disabled: "" } }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "section-description" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("chatbotv2.diagramExportDesc")) +
                    "\n                "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "export-section" }, [
              _c(
                "div",
                { staticClass: "section-header" },
                [
                  _c("span", { staticClass: "section-title" }, [
                    _vm._v(_vm._s(_vm.$t("chatbotv2.aiSettings"))),
                  ]),
                  _vm._v(" "),
                  _c("a-switch", {
                    attrs: { disabled: !_vm.hasAiSettings },
                    model: {
                      value: _vm.exportOptions.aiSettings,
                      callback: function ($$v) {
                        _vm.$set(_vm.exportOptions, "aiSettings", $$v)
                      },
                      expression: "exportOptions.aiSettings",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "section-description" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("chatbotv2.aiSettingsExportDesc")) +
                    "\n                "
                ),
              ]),
              _vm._v(" "),
              _vm.exportOptions.aiSettings && _vm.hasAiSettings
                ? _c("div", { staticClass: "ai-settings-details" }, [
                    _c("div", { staticClass: "detail-item" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v(_vm._s(_vm.$t("chatbotv2.model")) + ":"),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.storyAi.model || "gpt-4.1")),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "detail-item" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v(_vm._s(_vm.$t("chatbotv2.temperature")) + ":"),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.storyAi.temperature || 0.7)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "detail-item" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v(_vm._s(_vm.$t("chatbotv2.topP")) + ":"),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.storyAi.top_p || 1)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "detail-item" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v(_vm._s(_vm.$t("chatbotv2.toolChoice")) + ":"),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.storyAi.tool_choice || "auto")),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.storyAi.prompt
                      ? _c("div", { staticClass: "detail-item" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v(_vm._s(_vm.$t("chatbotv2.prompt")) + ":"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "value truncate" }, [
                            _vm._v(
                              _vm._s(_vm.storyAi.prompt.substring(0, 100)) +
                                "..."
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _vm.kbCounts.aiFunction > 0
              ? _c("div", { staticClass: "export-section" }, [
                  _c(
                    "div",
                    { staticClass: "section-header" },
                    [
                      _c("span", { staticClass: "section-title" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("chatbotv2.aiFunctions")) +
                            "\n                        "
                        ),
                        _c("span", { staticClass: "count-badge" }, [
                          _vm._v(_vm._s(_vm.kbCounts.aiFunction)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("a-switch", {
                        model: {
                          value: _vm.exportOptions.aiFunctions,
                          callback: function ($$v) {
                            _vm.$set(_vm.exportOptions, "aiFunctions", $$v)
                          },
                          expression: "exportOptions.aiFunctions",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "section-description" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("chatbotv2.aiFunctionsExportDesc")) +
                        "\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.exportOptions.aiFunctions &&
                  _vm.aiFunctionsList.length > 0
                    ? _c(
                        "div",
                        { staticClass: "function-list" },
                        [
                          _c(
                            "div",
                            { staticClass: "select-all-row" },
                            [
                              _c(
                                "a-checkbox",
                                {
                                  attrs: {
                                    checked: _vm.isAllFunctionsSelected,
                                    indeterminate:
                                      _vm.isSomeFunctionsSelected &&
                                      !_vm.isAllFunctionsSelected,
                                  },
                                  on: { change: _vm.toggleAllFunctions },
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.$t("chatbotv2.selectAll")) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.aiFunctionsList, function (fn) {
                            return _c(
                              "div",
                              { key: fn._id, staticClass: "function-item" },
                              [
                                _c(
                                  "a-checkbox",
                                  {
                                    attrs: {
                                      checked: _vm.selectedFunctions.includes(
                                        fn._id
                                      ),
                                    },
                                    on: {
                                      change: function (e) {
                                        return _vm.toggleFunction(
                                          fn._id,
                                          e.target.checked
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(fn.aiFunction.name) +
                                        "\n                        "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          }),
                        ],
                        2
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "export-section" }, [
              _c("div", { staticClass: "section-header" }, [
                _c("span", { staticClass: "section-title" }, [
                  _vm._v(_vm._s(_vm.$t("chatbotv2.knowledgeBase"))),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "section-description" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("chatbotv2.knowledgeBaseExportDesc")) +
                    "\n                "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "kb-options" }, [
                _vm.kbCounts.faq > 0
                  ? _c(
                      "div",
                      { staticClass: "kb-option" },
                      [
                        _c("div", { staticClass: "kb-option-info" }, [
                          _c("span", { staticClass: "kb-name" }, [
                            _vm._v("FAQ"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "kb-count" }, [
                            _vm._v(
                              _vm._s(_vm.kbCounts.faq) +
                                " " +
                                _vm._s(_vm.$t("auto.chatbotKbItemsSuffix"))
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("a-switch", {
                          model: {
                            value: _vm.exportOptions.kb.faq,
                            callback: function ($$v) {
                              _vm.$set(_vm.exportOptions.kb, "faq", $$v)
                            },
                            expression: "exportOptions.kb.faq",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.kbCounts.file > 0
                  ? _c(
                      "div",
                      { staticClass: "kb-option" },
                      [
                        _c("div", { staticClass: "kb-option-info" }, [
                          _c("span", { staticClass: "kb-name" }, [
                            _vm._v(_vm._s(_vm.$t("chatbotv2.files"))),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "kb-count" }, [
                            _vm._v(
                              _vm._s(_vm.kbCounts.file) +
                                " " +
                                _vm._s(_vm.$t("auto.kbItemsSuffix"))
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("a-switch", {
                          model: {
                            value: _vm.exportOptions.kb.file,
                            callback: function ($$v) {
                              _vm.$set(_vm.exportOptions.kb, "file", $$v)
                            },
                            expression: "exportOptions.kb.file",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.kbCounts.article > 0
                  ? _c(
                      "div",
                      { staticClass: "kb-option" },
                      [
                        _c("div", { staticClass: "kb-option-info" }, [
                          _c("span", { staticClass: "kb-name" }, [
                            _vm._v(_vm._s(_vm.$t("chatbotv2.articles"))),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "kb-count" }, [
                            _vm._v(
                              _vm._s(_vm.kbCounts.article) +
                                " " +
                                _vm._s(_vm.$t("auto.chatbotKbItemsSuffix"))
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("a-switch", {
                          model: {
                            value: _vm.exportOptions.kb.article,
                            callback: function ($$v) {
                              _vm.$set(_vm.exportOptions.kb, "article", $$v)
                            },
                            expression: "exportOptions.kb.article",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.kbCounts.webpage > 0
                  ? _c(
                      "div",
                      { staticClass: "kb-option" },
                      [
                        _c("div", { staticClass: "kb-option-info" }, [
                          _c("span", { staticClass: "kb-name" }, [
                            _vm._v(_vm._s(_vm.$t("chatbotv2.webPages"))),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "kb-count" }, [
                            _vm._v(
                              _vm._s(_vm.kbCounts.webpage) +
                                " " +
                                _vm._s(_vm.$t("auto.chatbotKbItemsSuffix"))
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("a-switch", {
                          model: {
                            value: _vm.exportOptions.kb.webpage,
                            callback: function ($$v) {
                              _vm.$set(_vm.exportOptions.kb, "webpage", $$v)
                            },
                            expression: "exportOptions.kb.webpage",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.totalKbCount === 0
                  ? _c("div", { staticClass: "no-kb-message" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("chatbotv2.noKnowledgeBase")) +
                          "\n                    "
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "export-actions" },
            [
              _c(
                "a-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.$emit("close")
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("message.cancel")) +
                      "\n            "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "a-button",
                {
                  attrs: { type: "primary", loading: _vm.exporting },
                  on: { click: _vm.exportToClipboard },
                },
                [
                  _c("a-icon", { attrs: { type: "export" } }),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("chatbotv2.exportToClipboard")) +
                      "\n            "
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }